<template>
    <div>
        <h3>违规人才管理</h3>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="问题类型">
                <el-select v-model="filter.type" placeholder="问题类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="label,value in map.user.violationType" :key="value" :value="value" :label="label"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="人才id">
                <el-input placeholder="人才id" v-model.number="filter.userId"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="type" label="问题类型">
                <template slot-scope="scope">{{map.user.violationType[scope.row.type]}}</template>>
            </el-table-column>
            <el-table-column prop="entityId" label="关联id"></el-table-column>
            <el-table-column prop="nickname" label="人才昵称"></el-table-column>
            <el-table-column prop="phoneNumber" label="人才手机号"></el-table-column>
            <el-table-column prop="createTime" label="触发时间"></el-table-column>
            <el-table-column prop="details" label="详情"></el-table-column>
            <el-table-column prop="" label="操作">
                <template slot-scope="scope">
                    <el-dropdown size="medium">
                        <span class="el-dropdown-link">
                            <i class="el-icon-menu" style="font-size: 24px;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="">
                                <a :href="`${frontUrl}/resume/detail/${scope.row.aesUserId}`" target="_blank">查看简历</a>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="scope.row.type === 1" command="">
                                <a :href="`/orders?cid=${scope.row.entityId}`" target="_blank">查看订单</a>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <br/>
        <div>
            <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="i=>pageNum=i" :page-size="limit" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from '../../datamap'

import api from '../api'
let {
    user
} = api
export default {
    name: 'violations',
    data() {
        return {
            map,
            filter: {
                type: '',
                userId: '',
            },
            loading: true,
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
        }
    },
    computed: {
        uid() {
            return this.$route.query.uid || '';
        },
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    created() {
        this.filter.userId = this.uid;
    },
    methods: {
        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1;
            }

            let {
                type,
                userId,
            } = this.filter;
            this.loading = true;
            let {
                data: {
                    data,
                    code,
                    desc,
                    pageinfo,
                }
            } = await user.violations({
                pageNum: this.pageNum,
                limit: this.limit,
                type,
                userId
            })
            if (code == 200) {
                this.list = data;
                this.total = pageinfo.totalCount;
            }
            this.loading = false;
        },
    },
    mounted() {
        this.fetch()
    }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/user/violations.vue